import React from "react";
import { UUID } from "../model/uuid";
import { TokenTagging } from "../model/structure";
import { TokenTaggingAnnotationScheme } from "./scheme";
import { Token as TokenModel } from "../model/structure";
import { TaggedToken as TaggedTokenModel } from "../model/structure";
import { TaggedToken } from "../structure/token/tagged-token";
import { useState } from "react";
import { MentionModel } from "../communication";
interface TokenTaggingAnnotationProps {
	annotationScheme: TokenTaggingAnnotationScheme;
	activeTypeIds: UUID[];
	activeStructureIds: [UUID, UUID, MentionModel][]
	activateStructureIds: (uuids: UUID[], tokenizationIds: UUID[],mentionModel:MentionModel) => UUID[];
	selectionBox?: React.CSSProperties;
	tokenList: TokenModel[];
	tokenTaggingList?: TokenTagging[];
}

interface TokenTaggingAnnotationState {
	taggedTokenList: TaggedTokenModel[];
}

export function TokenTaggingAnnotation(props: TokenTaggingAnnotationProps) {
	const [state, setState] = useState<TokenTaggingAnnotationState>(
		_initTaggedTokenList()
	);

	/**
	 * Function to initialize TokenTaggingAnnotationState
	 * 
	 * @returns 
	 * TaggedTokenAnnotationState Object 
	 */
	function _initTaggedTokenList() {
		const defaultTaggedTokenList = props.tokenList.map((elem) => ({
			tokenIndex: elem.tokenIndex,
		}));

		if (props.tokenTaggingList !== undefined) {
			const tokenTagging = props.tokenTaggingList.find(
				(elem) =>
					elem.metadata.tool ===
						props.annotationScheme.metadata?.tool &&
					elem.metadata.timestamp ===
						props.annotationScheme.metadata?.timestamp
			);

			if (tokenTagging !== undefined) {
				return { taggedTokenList: tokenTagging.taggedTokenList };
			} else {
				return { taggedTokenList: defaultTaggedTokenList };
			}
		} else {
			return { taggedTokenList: defaultTaggedTokenList };
		}
	}

	/**
	 * Function to get the value of type in ontology 
	 * 
	 * @param typeId 
	 * UUID of the type from ontology
	 * @returns 
	 * Value of the uuid associated with type (eg- NN,VBD)
	 */
	function _getTypeValue(typeId: UUID | null) {
		if (typeId === null) {
			return "";
		} else {
			const type = props.annotationScheme.ontology.types.find(
				(t) => t.uuid.uuidString === typeId.uuidString
			);

			if (type === undefined) {
				return "";
			} else {
				return type.value;
			}
		}
	}

	/**
	 * Function to handle click events
	 * @param tokenIndex 
	 * Index of the token click
	 * @param typeId 
	 * uuid of the type associated in the ontology
	 * @param e 
	 * MouseEvent Handler
	 */
	function handleClick(
		tokenIndex: number,
		typeId: UUID | null,
		e?: React.MouseEvent
	) {
		if ((e === undefined || e.metaKey || e.ctrlKey) && typeId !== null) {
			const tag = _getTypeValue(typeId);
			let taggedTokenList = state.taggedTokenList.slice();
			let taggedToken = taggedTokenList.find((elem) =>
				elem.tokenIndex !== undefined
					? elem.tokenIndex === tokenIndex
					: false
			);

			if (taggedToken !== undefined) {
				taggedToken.tag = tag;
				taggedTokenList = taggedTokenList.filter(
					(elem) => elem.tokenIndex !== tokenIndex
				);
			} else {
				taggedToken = { tokenIndex: tokenIndex, tag: tag };
			}

			taggedTokenList.push(taggedToken);

			setState({ taggedTokenList: taggedTokenList });
		}
	}

	/**
	 * Function to render the TaggedTokens present in the tokenization
	 * 
	 * @returns 
	 * List of TaggedTokens
	 */
	function render() {
		const activeTypeId =
			props.activeTypeIds.length > 0 ? props.activeTypeIds[0] : null;

		return (
			<>
				{props.tokenList.map((ps) => (
					<TaggedToken
						key={"token-" + ps.tokenIndex}
						annotationScheme={props.annotationScheme}
						activeTypeId={props.activeTypeIds[0]}
						taggedToken={state.taggedTokenList.find((elem) =>
							elem.tokenIndex !== undefined
								? elem.tokenIndex === ps.tokenIndex
								: false
						)}
						onClick={(e: React.MouseEvent) => {
							handleClick(ps.tokenIndex, activeTypeId, e);
						}}
						onSelect={(tid) => handleClick(ps.tokenIndex, tid)}
						{...ps}
					/>
				))}
			</>
		);
	}

	return render();
}
